import { ETypCertifikatu } from 'enums/isin/udaje/typCertifikatu';

const typCertifikatuSelect = [
    {
        value: ETypCertifikatu.S,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_TYP_S'
    },
    {
        value: ETypCertifikatu.V,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_TYP_CNV'
    },
    {
        value: ETypCertifikatu.B,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_TYP_B'
    },
    {
        value: ETypCertifikatu.BV,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_TYP_BNV'
    },
    {
        value: ETypCertifikatu.D,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_TYP_CDV'
    },
    {
        value: ETypCertifikatu.O,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_TYP_O'
    }
];

export default typCertifikatuSelect;
